import styled from 'styled-components';

export default styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/title.js